import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import { convertHexaOrHexToRGBAUnits } from '@wix/editor-elements-common-utils';
import type { RepeaterDefinition } from '@wix/thunderbolt-components';

import type {
  IResponsiveRepeaterProps,
  IStudioRepeaterCSSVars,
} from '../ResponsiveRepeater.types';

export const props = withCompInfo<
  IResponsiveRepeaterProps,
  RepeaterDefinition,
  IResponsiveRepeaterProps
>()(['isMasterPage'], ({ isMasterPage }, carmiData) => {
  return {
    ...carmiData,
    isMasterPage,
  };
});

export const css = withCompInfo<
  IStudioRepeaterCSSVars,
  RepeaterDefinition,
  Record<string, any>
>()(
  ['styleProperties', 'editorName'],
  ({ editorName, styleProperties }, carmiData = {}) => {
    const { shd, bg, brd, brw, rd } = styleProperties;
    const borderColorRGB = convertHexaOrHexToRGBAUnits(brd)?.slice(0, 3);
    const isShadowEnabled = styleProperties['boxShadowToggleOn-shd'] === 'true';

    if (editorName === 'Studio') {
      return {
        ...carmiData,
        '--boxShadow': isShadowEnabled ? shd : 'none',
        '--backgroundColor': bg,
        '--borderColor': borderColorRGB,
        '--borderWidth': brw,
        '--borderRadius': rd,
        '--alpha-borderColor': styleProperties['alpha-brd'],
      };
    }

    return carmiData;
  },
);

export const stateRefs = withStateRefsValues([
  'observeChildListChange',
  'observeChildListChangeMaster',
]);

export default createComponentMapperModel({ css, stateRefs, props });
